//AgriculturalUse.tsx ==============================================================
import "../Util/Prototypes";

import React from "react";

import { Paper } from "@mui/material";

//Clear this tool.
export function clearTool() {
}

//Render function.
export function Render() {
   return (
      <Paper>
      </Paper>
   ); //end return.

} //end function.
